// extracted by mini-css-extract-plugin
export default {"wrapper":"Auth_wrapper__hK7FJ","logo":"Auth_logo__6gr7X","form":"Auth_form__1XxrB","email":"Auth_email__dhgHE"};